// extracted by mini-css-extract-plugin
export default {"redFont":"zRPdEixJb1eRg8lOtipHu","greenFont":"qf8zqUWbYvfWza8CmYd6C","orangeFont":"_20H_Owcf4dQkGeJU7TSdYU"};